import React from "react";
import "./order.css";

function Order({ order }) {
  return <div className="order">This is an order</div>;
}

export default Order;
